import script from "./Activity_Info.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_Info.vue?vue&type=script&setup=true&lang=js"

import "./Activity_Info.vue?vue&type=style&index=0&id=12e784b2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e784b2"]])

export default __exports__